if (!customElements.get("collection-navigation")) {
  class CollectionNavigation extends HTMLElement {
    constructor() {
      super();

      this.handleResize =
        this.handleResize.bind(this);

      this.handleWheel =
        this.handleWheel.bind(this);

      this.resizeTimer = null;
    }

    connectedCallback() {
      this.scroller = this.querySelector(
        "[data-collection-navigation-scroll]"
      );

      this.activeItem = this.querySelector(
        "[data-collection-navigation-active]"
      );

      if (!this.scroller) {
        return;
      }

      if (this.activeItem) {
        requestAnimationFrame(() => {
          this.scrollActiveIntoView(false);
        });
      }

      window.addEventListener(
        "resize",
        this.handleResize
      );

      this.scroller.addEventListener(
        "wheel",
        this.handleWheel,
        { passive: false }
      );
    }

    disconnectedCallback() {
      window.removeEventListener(
        "resize",
        this.handleResize
      );

      if (this.scroller) {
        this.scroller.removeEventListener(
          "wheel",
          this.handleWheel
        );
      }

      clearTimeout(this.resizeTimer);
    }

    handleResize() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        if (this.activeItem) {
          this.scrollActiveIntoView(false);
        }
      }, 150);
    }

    handleWheel(event) {
      if (!this.scroller) return;

      const canScrollHorizontally =
        this.scroller.scrollWidth >
        this.scroller.clientWidth;

      if (!canScrollHorizontally) {
        return;
      }

      /*
       * Trackpad:
       * deltaX already horizontal hota hai.
       *
       * Mouse wheel:
       * deltaY vertical hota hai, usko horizontal
       * scroll mein convert kar dete hain.
       */
      const delta =
        Math.abs(event.deltaX) > Math.abs(event.deltaY)
          ? event.deltaX
          : event.deltaY;

      if (!delta) return;

      const currentScroll =
        this.scroller.scrollLeft;

      const maxScroll =
        this.scroller.scrollWidth -
        this.scroller.clientWidth;

      const scrollingRight = delta > 0;
      const scrollingLeft = delta < 0;

      const atStart =
        currentScroll <= 0;

      const atEnd =
        currentScroll >= maxScroll - 1;

      /*
       * Jab horizontal scroll ki direction mein
       * aur space available ho tab page ka normal
       * vertical scroll prevent karenge.
       *
       * Start/end par user ko page scroll karne denge.
       */
      if (
        (scrollingRight && !atEnd) ||
        (scrollingLeft && !atStart)
      ) {
        event.preventDefault();

        this.scroller.scrollLeft += delta;
      }
    }

    scrollActiveIntoView(smooth = false) {
      if (!this.scroller || !this.activeItem) {
        return;
      }

      if (
        this.scroller.scrollWidth <=
        this.scroller.clientWidth
      ) {
        this.scroller.scrollLeft = 0;
        return;
      }

      const scrollerWidth =
        this.scroller.clientWidth;

      const itemLeft =
        this.activeItem.offsetLeft;

      const itemWidth =
        this.activeItem.offsetWidth;

      const target =
        itemLeft -
        scrollerWidth / 2 +
        itemWidth / 2;

      const maxScroll =
        this.scroller.scrollWidth -
        this.scroller.clientWidth;

      const finalTarget = Math.max(
        0,
        Math.min(target, maxScroll)
      );

      this.scroller.scrollTo({
        left: finalTarget,
        behavior: smooth ? "smooth" : "auto"
      });
    }
  }

  customElements.define(
    "collection-navigation",
    CollectionNavigation
  );
}